module.exports = __webpack_public_path__ + "img/Pink Standard.d8f30735.jpg";